import React from 'react';
import { Typography } from '@progress/kendo-react-common';
import GearPage from './GearPage';
import { useGlobalizationContext } from '../context/globalization/GlobalizationContext';
import { useTranslation } from '../context/globalization/useTranslation';

interface BrowserInfo {
  supported: boolean;
  browser: string;
  version: number;
  minVersion?: number;
}

interface Props {
  browserInfo: BrowserInfo;
}

export const UnsupportedBrowserPage: React.FC<Props> = ({ browserInfo }) => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);

  const browserLinks = {
    chrome: 'https://www.google.com/chrome/',
    firefox: 'https://www.mozilla.org/firefox/',
    edge: 'https://www.microsoft.com/edge',
    safari: 'https://www.apple.com/safari/'
  };

  return (
    <GearPage className="gearPage--unsupportedBrowser">
      <Typography.h2>{translate('custom.unsupportedBrowserPage.title')}</Typography.h2>
      <Typography.p>
        {browserInfo.minVersion
          ? translate('custom.unsupportedBrowserPage.description', {
              browser: browserInfo.browser,
              version: browserInfo.version,
              minVersion: browserInfo.minVersion
            })
          : translate('custom.unsupportedBrowserPage.descriptionNoVersion', {
              browser: browserInfo.browser,
              version: browserInfo.version
            })}
      </Typography.p>
      <Typography.p>{translate('custom.unsupportedBrowserPage.instruction')}</Typography.p>
      <div className="browsersList">
        <a href={browserLinks.chrome} target="_blank" rel="noreferrer">
          Chrome
        </a>
        <a href={browserLinks.firefox} target="_blank" rel="noreferrer">
          Firefox
        </a>
        <a href={browserLinks.edge} target="_blank" rel="noreferrer">
          Edge
        </a>
      </div>
    </GearPage>
  );
};
